


































import {defineComponent, PropType, ref} from "@vue/composition-api";
import AppLayout from "@tool/Layouts/AppLayout.vue";
import Breadcrumbs from "@tool/Components/Breadcrumbs.vue";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import BlockMessage from "@base/Components/BlockMessage.vue";
import {TeamEntityInterface} from "@tool/tool.types";
import useAppStore from "@tool/store/useAppStore";
import useSwal from "@tool/Helpers/useSwal";
import useAxios from "@tool/Helpers/useAxios";
import FormError from "@tool/Components/FormError.vue";
import useFormHelper from "@tool/Helpers/useFormHelper";
import {BvModalEvent} from "bootstrap-vue/src/components/modal";
import {useInertia} from "@tool/Helpers/useInertia";
import useInertiaData from "@tool/Helpers/useInertiaData";

export default defineComponent({
    components: {
        Breadcrumbs,
        AppLayout,
        ThemeBlock,
        BlockMessage,
        FormError
    },
    props: {
        teams: {
            type: Array as PropType<TeamEntityInterface[]>,
            required: true
        },
        canCreateTeam: {
            type: Boolean,
            required: true
        }
    },
    setup(props) {

        const inertiaData = useInertiaData();
        const user = inertiaData.value.user;

        const createTeamSubmit = async (event: BvModalEvent) => {
            event.preventDefault();

            if (!props.canCreateTeam) {
                useSwal().fire({title: 'You already own a team', icon: 'error'});
                return;
            }

            const response = await createTeamForm.value.submit((data) => {
                return useAxios().post<TeamEntityInterface>(route('app.teams.store'), {
                    name: data.name
                })
            });

            if (response.success) {
                useInertia().get(route('app.team.projects.index', response.success.id), {}, {
                    onFinish() {
                        useSwal().fire({
                            title: 'Teams was successfully created',
                            icon: 'success'
                        });
                    }
                });
            }
        }

        const createTeamForm = useFormHelper({
            name: `${user.name_first}'s Team`,
        })

        const createTeamShowModal = ref(false);


        return {
            user,
            createTeamForm,
            createTeamShowModal,
            createTeamSubmit,
        }
    }
})
